import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Vehicles from './pages/Vehicles';
import Defects from './pages/Defects';
import Inspections from './pages/Inspections';
import Compliance from './pages/Compliance';
import Checklists from './pages/Checklists';
import Tacho from './pages/Tacho';
import Settings from './pages/Settings';
import Layout from './components/Layout';

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      {!user ? (
        <Route path="/login" element={<Login />} />
      ) : (
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="vehicles" element={<Vehicles />} />
          <Route path="defects" element={<Defects />} />
          <Route path="inspections" element={<Inspections />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="/checklists" element={<Checklists />} />
          <Route path="/tacho" element={<Tacho />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      )}
      <Route path="*" element={<Navigate to={user ? "/" : "/login"} />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
